/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';
import {
  AnalyzeContext,
  AnalyzeIssue,
  AnalyzeResult,
  getDataStoreItem,
} from 'layout/Sidebar/panels/TreeView/AnalyzeUtils';
import { getManager } from '../../registry/Manager';

export async function analyzeActionDelete({
  page,
  itemId,
  mgr,
}: AnalyzeContext): Promise<AnalyzeResult> {
  const alerts: AnalyzeIssue[] = [];
  const autoFixes: (() => void)[] = [];
  const item = page[itemId] as Item<'ActionDeleteCurrentRecord'>;
  if (item.props.alias) {
    const dsItem = getDataStoreItem({ page, alias: item.props.alias });
    if (dsItem && dsItem.type === 'ReadOnlyDataStore') {
      const m = getManager(dsItem.type);
      alerts.push({
        key: `invalid-ds-${itemId}`,
        showItemId: itemId,
        alert: `${m.name} [${item.props.alias}] cannot be used in ${mgr.name}!`,
        itemId,
      });
    }
  }
  return [alerts, autoFixes];
}
